/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OSlugRouteImport } from './routes/o.$slug'
import { Route as OSlugIndexRouteImport } from './routes/o.$slug.index'
import { Route as OSlugSyncStatusRouteImport } from './routes/o.$slug.sync-status'
import { Route as OSlugNotesRouteImport } from './routes/o.$slug.notes'
import { Route as OSlugEmployeesRouteImport } from './routes/o.$slug.employees'
import { Route as OSlugDriveRouteImport } from './routes/o.$slug.drive'
import { Route as OSlugContractsRouteImport } from './routes/o.$slug.contracts'
import { Route as OSlugCompaniesRouteImport } from './routes/o.$slug.companies'
import { Route as OSlugCalendarRouteImport } from './routes/o.$slug.calendar'
import { Route as OSlugNotesIndexRouteImport } from './routes/o.$slug.notes.index'
import { Route as OSlugEmployeesIndexRouteImport } from './routes/o.$slug.employees.index'
import { Route as OSlugContractsIndexRouteImport } from './routes/o.$slug.contracts.index'
import { Route as OSlugCalendarIndexRouteImport } from './routes/o.$slug.calendar.index'
import { Route as OSlugNotesNoteIdRouteImport } from './routes/o.$slug.notes.$noteId'
import { Route as OSlugContractsNewRouteImport } from './routes/o.$slug.contracts.new'
import { Route as OSlugContractsContractIdRouteImport } from './routes/o.$slug.contracts.$contractId'
import { Route as OSlugEmployeesCompanyIdOrdioIdentityIdRouteImport } from './routes/o.$slug.employees.$companyId.$ordioIdentityId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OSlugRoute = OSlugRouteImport.update({
  id: '/o/$slug',
  path: '/o/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OSlugIndexRoute = OSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugSyncStatusRoute = OSlugSyncStatusRouteImport.update({
  id: '/sync-status',
  path: '/sync-status',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugNotesRoute = OSlugNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugEmployeesRoute = OSlugEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugDriveRoute = OSlugDriveRouteImport.update({
  id: '/drive',
  path: '/drive',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugContractsRoute = OSlugContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugCompaniesRoute = OSlugCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugCalendarRoute = OSlugCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => OSlugRoute,
} as any)
const OSlugNotesIndexRoute = OSlugNotesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OSlugNotesRoute,
} as any)
const OSlugEmployeesIndexRoute = OSlugEmployeesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OSlugEmployeesRoute,
} as any)
const OSlugContractsIndexRoute = OSlugContractsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OSlugContractsRoute,
} as any)
const OSlugCalendarIndexRoute = OSlugCalendarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OSlugCalendarRoute,
} as any)
const OSlugNotesNoteIdRoute = OSlugNotesNoteIdRouteImport.update({
  id: '/$noteId',
  path: '/$noteId',
  getParentRoute: () => OSlugNotesRoute,
} as any)
const OSlugContractsNewRoute = OSlugContractsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OSlugContractsRoute,
} as any)
const OSlugContractsContractIdRoute =
  OSlugContractsContractIdRouteImport.update({
    id: '/$contractId',
    path: '/$contractId',
    getParentRoute: () => OSlugContractsRoute,
  } as any)
const OSlugEmployeesCompanyIdOrdioIdentityIdRoute =
  OSlugEmployeesCompanyIdOrdioIdentityIdRouteImport.update({
    id: '/$companyId/$ordioIdentityId',
    path: '/$companyId/$ordioIdentityId',
    getParentRoute: () => OSlugEmployeesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/o/$slug': typeof OSlugRouteWithChildren
  '/o/$slug/calendar': typeof OSlugCalendarRouteWithChildren
  '/o/$slug/companies': typeof OSlugCompaniesRoute
  '/o/$slug/contracts': typeof OSlugContractsRouteWithChildren
  '/o/$slug/drive': typeof OSlugDriveRoute
  '/o/$slug/employees': typeof OSlugEmployeesRouteWithChildren
  '/o/$slug/notes': typeof OSlugNotesRouteWithChildren
  '/o/$slug/sync-status': typeof OSlugSyncStatusRoute
  '/o/$slug/': typeof OSlugIndexRoute
  '/o/$slug/contracts/$contractId': typeof OSlugContractsContractIdRoute
  '/o/$slug/contracts/new': typeof OSlugContractsNewRoute
  '/o/$slug/notes/$noteId': typeof OSlugNotesNoteIdRoute
  '/o/$slug/calendar/': typeof OSlugCalendarIndexRoute
  '/o/$slug/contracts/': typeof OSlugContractsIndexRoute
  '/o/$slug/employees/': typeof OSlugEmployeesIndexRoute
  '/o/$slug/notes/': typeof OSlugNotesIndexRoute
  '/o/$slug/employees/$companyId/$ordioIdentityId': typeof OSlugEmployeesCompanyIdOrdioIdentityIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/o/$slug/companies': typeof OSlugCompaniesRoute
  '/o/$slug/drive': typeof OSlugDriveRoute
  '/o/$slug/sync-status': typeof OSlugSyncStatusRoute
  '/o/$slug': typeof OSlugIndexRoute
  '/o/$slug/contracts/$contractId': typeof OSlugContractsContractIdRoute
  '/o/$slug/contracts/new': typeof OSlugContractsNewRoute
  '/o/$slug/notes/$noteId': typeof OSlugNotesNoteIdRoute
  '/o/$slug/calendar': typeof OSlugCalendarIndexRoute
  '/o/$slug/contracts': typeof OSlugContractsIndexRoute
  '/o/$slug/employees': typeof OSlugEmployeesIndexRoute
  '/o/$slug/notes': typeof OSlugNotesIndexRoute
  '/o/$slug/employees/$companyId/$ordioIdentityId': typeof OSlugEmployeesCompanyIdOrdioIdentityIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/o/$slug': typeof OSlugRouteWithChildren
  '/o/$slug/calendar': typeof OSlugCalendarRouteWithChildren
  '/o/$slug/companies': typeof OSlugCompaniesRoute
  '/o/$slug/contracts': typeof OSlugContractsRouteWithChildren
  '/o/$slug/drive': typeof OSlugDriveRoute
  '/o/$slug/employees': typeof OSlugEmployeesRouteWithChildren
  '/o/$slug/notes': typeof OSlugNotesRouteWithChildren
  '/o/$slug/sync-status': typeof OSlugSyncStatusRoute
  '/o/$slug/': typeof OSlugIndexRoute
  '/o/$slug/contracts/$contractId': typeof OSlugContractsContractIdRoute
  '/o/$slug/contracts/new': typeof OSlugContractsNewRoute
  '/o/$slug/notes/$noteId': typeof OSlugNotesNoteIdRoute
  '/o/$slug/calendar/': typeof OSlugCalendarIndexRoute
  '/o/$slug/contracts/': typeof OSlugContractsIndexRoute
  '/o/$slug/employees/': typeof OSlugEmployeesIndexRoute
  '/o/$slug/notes/': typeof OSlugNotesIndexRoute
  '/o/$slug/employees/$companyId/$ordioIdentityId': typeof OSlugEmployeesCompanyIdOrdioIdentityIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/o/$slug'
    | '/o/$slug/calendar'
    | '/o/$slug/companies'
    | '/o/$slug/contracts'
    | '/o/$slug/drive'
    | '/o/$slug/employees'
    | '/o/$slug/notes'
    | '/o/$slug/sync-status'
    | '/o/$slug/'
    | '/o/$slug/contracts/$contractId'
    | '/o/$slug/contracts/new'
    | '/o/$slug/notes/$noteId'
    | '/o/$slug/calendar/'
    | '/o/$slug/contracts/'
    | '/o/$slug/employees/'
    | '/o/$slug/notes/'
    | '/o/$slug/employees/$companyId/$ordioIdentityId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/o/$slug/companies'
    | '/o/$slug/drive'
    | '/o/$slug/sync-status'
    | '/o/$slug'
    | '/o/$slug/contracts/$contractId'
    | '/o/$slug/contracts/new'
    | '/o/$slug/notes/$noteId'
    | '/o/$slug/calendar'
    | '/o/$slug/contracts'
    | '/o/$slug/employees'
    | '/o/$slug/notes'
    | '/o/$slug/employees/$companyId/$ordioIdentityId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/o/$slug'
    | '/o/$slug/calendar'
    | '/o/$slug/companies'
    | '/o/$slug/contracts'
    | '/o/$slug/drive'
    | '/o/$slug/employees'
    | '/o/$slug/notes'
    | '/o/$slug/sync-status'
    | '/o/$slug/'
    | '/o/$slug/contracts/$contractId'
    | '/o/$slug/contracts/new'
    | '/o/$slug/notes/$noteId'
    | '/o/$slug/calendar/'
    | '/o/$slug/contracts/'
    | '/o/$slug/employees/'
    | '/o/$slug/notes/'
    | '/o/$slug/employees/$companyId/$ordioIdentityId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  OSlugRoute: typeof OSlugRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$slug': {
      id: '/o/$slug'
      path: '/o/$slug'
      fullPath: '/o/$slug'
      preLoaderRoute: typeof OSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/o/$slug/': {
      id: '/o/$slug/'
      path: '/'
      fullPath: '/o/$slug/'
      preLoaderRoute: typeof OSlugIndexRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/sync-status': {
      id: '/o/$slug/sync-status'
      path: '/sync-status'
      fullPath: '/o/$slug/sync-status'
      preLoaderRoute: typeof OSlugSyncStatusRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/notes': {
      id: '/o/$slug/notes'
      path: '/notes'
      fullPath: '/o/$slug/notes'
      preLoaderRoute: typeof OSlugNotesRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/employees': {
      id: '/o/$slug/employees'
      path: '/employees'
      fullPath: '/o/$slug/employees'
      preLoaderRoute: typeof OSlugEmployeesRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/drive': {
      id: '/o/$slug/drive'
      path: '/drive'
      fullPath: '/o/$slug/drive'
      preLoaderRoute: typeof OSlugDriveRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/contracts': {
      id: '/o/$slug/contracts'
      path: '/contracts'
      fullPath: '/o/$slug/contracts'
      preLoaderRoute: typeof OSlugContractsRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/companies': {
      id: '/o/$slug/companies'
      path: '/companies'
      fullPath: '/o/$slug/companies'
      preLoaderRoute: typeof OSlugCompaniesRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/calendar': {
      id: '/o/$slug/calendar'
      path: '/calendar'
      fullPath: '/o/$slug/calendar'
      preLoaderRoute: typeof OSlugCalendarRouteImport
      parentRoute: typeof OSlugRoute
    }
    '/o/$slug/notes/': {
      id: '/o/$slug/notes/'
      path: '/'
      fullPath: '/o/$slug/notes/'
      preLoaderRoute: typeof OSlugNotesIndexRouteImport
      parentRoute: typeof OSlugNotesRoute
    }
    '/o/$slug/employees/': {
      id: '/o/$slug/employees/'
      path: '/'
      fullPath: '/o/$slug/employees/'
      preLoaderRoute: typeof OSlugEmployeesIndexRouteImport
      parentRoute: typeof OSlugEmployeesRoute
    }
    '/o/$slug/contracts/': {
      id: '/o/$slug/contracts/'
      path: '/'
      fullPath: '/o/$slug/contracts/'
      preLoaderRoute: typeof OSlugContractsIndexRouteImport
      parentRoute: typeof OSlugContractsRoute
    }
    '/o/$slug/calendar/': {
      id: '/o/$slug/calendar/'
      path: '/'
      fullPath: '/o/$slug/calendar/'
      preLoaderRoute: typeof OSlugCalendarIndexRouteImport
      parentRoute: typeof OSlugCalendarRoute
    }
    '/o/$slug/notes/$noteId': {
      id: '/o/$slug/notes/$noteId'
      path: '/$noteId'
      fullPath: '/o/$slug/notes/$noteId'
      preLoaderRoute: typeof OSlugNotesNoteIdRouteImport
      parentRoute: typeof OSlugNotesRoute
    }
    '/o/$slug/contracts/new': {
      id: '/o/$slug/contracts/new'
      path: '/new'
      fullPath: '/o/$slug/contracts/new'
      preLoaderRoute: typeof OSlugContractsNewRouteImport
      parentRoute: typeof OSlugContractsRoute
    }
    '/o/$slug/contracts/$contractId': {
      id: '/o/$slug/contracts/$contractId'
      path: '/$contractId'
      fullPath: '/o/$slug/contracts/$contractId'
      preLoaderRoute: typeof OSlugContractsContractIdRouteImport
      parentRoute: typeof OSlugContractsRoute
    }
    '/o/$slug/employees/$companyId/$ordioIdentityId': {
      id: '/o/$slug/employees/$companyId/$ordioIdentityId'
      path: '/$companyId/$ordioIdentityId'
      fullPath: '/o/$slug/employees/$companyId/$ordioIdentityId'
      preLoaderRoute: typeof OSlugEmployeesCompanyIdOrdioIdentityIdRouteImport
      parentRoute: typeof OSlugEmployeesRoute
    }
  }
}

interface OSlugCalendarRouteChildren {
  OSlugCalendarIndexRoute: typeof OSlugCalendarIndexRoute
}

const OSlugCalendarRouteChildren: OSlugCalendarRouteChildren = {
  OSlugCalendarIndexRoute: OSlugCalendarIndexRoute,
}

const OSlugCalendarRouteWithChildren = OSlugCalendarRoute._addFileChildren(
  OSlugCalendarRouteChildren,
)

interface OSlugContractsRouteChildren {
  OSlugContractsContractIdRoute: typeof OSlugContractsContractIdRoute
  OSlugContractsNewRoute: typeof OSlugContractsNewRoute
  OSlugContractsIndexRoute: typeof OSlugContractsIndexRoute
}

const OSlugContractsRouteChildren: OSlugContractsRouteChildren = {
  OSlugContractsContractIdRoute: OSlugContractsContractIdRoute,
  OSlugContractsNewRoute: OSlugContractsNewRoute,
  OSlugContractsIndexRoute: OSlugContractsIndexRoute,
}

const OSlugContractsRouteWithChildren = OSlugContractsRoute._addFileChildren(
  OSlugContractsRouteChildren,
)

interface OSlugEmployeesRouteChildren {
  OSlugEmployeesIndexRoute: typeof OSlugEmployeesIndexRoute
  OSlugEmployeesCompanyIdOrdioIdentityIdRoute: typeof OSlugEmployeesCompanyIdOrdioIdentityIdRoute
}

const OSlugEmployeesRouteChildren: OSlugEmployeesRouteChildren = {
  OSlugEmployeesIndexRoute: OSlugEmployeesIndexRoute,
  OSlugEmployeesCompanyIdOrdioIdentityIdRoute:
    OSlugEmployeesCompanyIdOrdioIdentityIdRoute,
}

const OSlugEmployeesRouteWithChildren = OSlugEmployeesRoute._addFileChildren(
  OSlugEmployeesRouteChildren,
)

interface OSlugNotesRouteChildren {
  OSlugNotesNoteIdRoute: typeof OSlugNotesNoteIdRoute
  OSlugNotesIndexRoute: typeof OSlugNotesIndexRoute
}

const OSlugNotesRouteChildren: OSlugNotesRouteChildren = {
  OSlugNotesNoteIdRoute: OSlugNotesNoteIdRoute,
  OSlugNotesIndexRoute: OSlugNotesIndexRoute,
}

const OSlugNotesRouteWithChildren = OSlugNotesRoute._addFileChildren(
  OSlugNotesRouteChildren,
)

interface OSlugRouteChildren {
  OSlugCalendarRoute: typeof OSlugCalendarRouteWithChildren
  OSlugCompaniesRoute: typeof OSlugCompaniesRoute
  OSlugContractsRoute: typeof OSlugContractsRouteWithChildren
  OSlugDriveRoute: typeof OSlugDriveRoute
  OSlugEmployeesRoute: typeof OSlugEmployeesRouteWithChildren
  OSlugNotesRoute: typeof OSlugNotesRouteWithChildren
  OSlugSyncStatusRoute: typeof OSlugSyncStatusRoute
  OSlugIndexRoute: typeof OSlugIndexRoute
}

const OSlugRouteChildren: OSlugRouteChildren = {
  OSlugCalendarRoute: OSlugCalendarRouteWithChildren,
  OSlugCompaniesRoute: OSlugCompaniesRoute,
  OSlugContractsRoute: OSlugContractsRouteWithChildren,
  OSlugDriveRoute: OSlugDriveRoute,
  OSlugEmployeesRoute: OSlugEmployeesRouteWithChildren,
  OSlugNotesRoute: OSlugNotesRouteWithChildren,
  OSlugSyncStatusRoute: OSlugSyncStatusRoute,
  OSlugIndexRoute: OSlugIndexRoute,
}

const OSlugRouteWithChildren = OSlugRoute._addFileChildren(OSlugRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  OSlugRoute: OSlugRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
